"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_virtualized_1 = require("react-virtualized");
var DataGridMobileCell_1 = __importDefault(require("./DataGridMobileCell"));
var props_1 = require("../../context/props");
var CellMeasurer = react_virtualized_1.CellMeasurer;
var DataGridMobileCell = function (props) {
    var _a;
    var cellMeasurerCache = props.cellMeasurerCache, dataKey = props.dataKey, parent = props.parent, rowIndex = props.rowIndex;
    var classes = (0, props_1.usePropsContext)().classes;
    return (react_1.default.createElement(CellMeasurer, { cache: cellMeasurerCache, columnIndex: 0, key: dataKey, parent: parent, rowIndex: rowIndex },
        react_1.default.createElement("div", { className: ((_a = classes === null || classes === void 0 ? void 0 : classes.cell) === null || _a === void 0 ? void 0 : _a.root) || '' },
            react_1.default.createElement(DataGridMobileCell_1.default, __assign({}, props)))));
};
exports.default = DataGridMobileCell;
